import { ROUTES } from '@app/AppRoutes/routes';
import { useNavigate } from 'react-router-dom';
import { NotificationAction } from '../types';

export function useNotificationClick() {
	const navigate = useNavigate();

	const applyOnClick = (action: NotificationAction) => {
		switch (action) {
			case NotificationAction.BILLING_CHANGE:
				navigate(ROUTES.SETTINGS.BILLING.path);
				break;
			default:
				break;
		}
	};

	return { applyOnClick };
}
